import { defineAttrs as t } from "../../utils/typed-attrs.js";
const o = t({
  type: { default: "twitterFollowButton" },
  username: { default: "" }
}), r = {
  content: "",
  group: "block",
  marks: "",
  atom: !0,
  attrs: o,
  toDOM() {
    return ["div"];
  }
};
export {
  r as twitterFollowButtonSpec
};
